import { render } from "./TardyManagementAdults.vue?vue&type=template&id=8a3f2bc4"
import script from "./TardyManagementAdults.vue?vue&type=script&lang=js"
export * from "./TardyManagementAdults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__